import { MAX_PROJECT_NAME_LENGTH, MIN_PROJECT_NAME_LENGTH } from '../../constants/constants';

export const updateProjectNames = (projects, updatedProjects = [], defaultValue = []) => {
    if (!updatedProjects?.length) return projects || defaultValue;

    return (
        projects?.map((project) => {
            const newName =
                updatedProjects.find((projectToUpdate) => project.id === projectToUpdate.id)
                    ?.name || project.name;

            return {
                ...project,
                name: newName,
            };
        }) || defaultValue
    );
};

export const removeProjectByIds = (projects, updatedProjects = [], defaultValue = []) => {
    return projects?.filter((project) => !updatedProjects.includes(project.id)) || defaultValue;
};

export const normalizeWhitespace = (value = '') => {
    return value.replace(/\s+/g, ' ').trim();
};

const isProjectNameUnique = (projects, nameToValidate, idToValidate = null) => {
    if (!idToValidate) {
        return !!nameToValidate?.length && !projects.some((p) => p.name === nameToValidate);
    }

    return (
        !!nameToValidate?.length &&
        !projects.some((p) => p.name === nameToValidate && idToValidate !== p.id)
    );
};

const isProjectNameLengthValid = (nameToValidate) => {
    return (
        nameToValidate?.length >= MIN_PROJECT_NAME_LENGTH &&
        nameToValidate?.length <= MAX_PROJECT_NAME_LENGTH
    );
};

const isProjectNameValid = (nameToValidate) => {
    return /[\p{L}\p{N}]/u.test(nameToValidate);
};

export const validateProjectName = (projects, nameToValidate, idToValidate = null) => {
    switch (true) {
        case !isProjectNameValid(nameToValidate):
            return 'Project name must contain at least one letter or number';
        case !isProjectNameLengthValid(nameToValidate):
            return `Project name must be between ${MIN_PROJECT_NAME_LENGTH} and ${MAX_PROJECT_NAME_LENGTH} characters long`;
        case !isProjectNameUnique(projects, nameToValidate, idToValidate):
            return 'Project already exists';
        default:
            return null;
    }
};
